//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {MCancelIconName, MOkIconName} from '../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../Toolkit/Components/Controls/Dialog';
import MButton from '../Toolkit/Components/Controls/Button';
import MTextArea from '../Toolkit/Components/Controls/TextArea';
import {MInputValueType} from '../Toolkit/Components/Controls/TextArea';

//endregion

/** */
type Props = {}

/** */
type State = {
    prompt: string,
    useLastNote: boolean,
    position?: DialogPositionType;
    visible: boolean;
    noteText: string;
    maxLength: number;
    onAddNote?: (data: string) => void;
}

/** */
class NoteDialog extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);
        this.onNoteChange = this.onNoteChange.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            prompt: '',
            maxLength: 10000,
            useLastNote: false,
            visible: false,
            noteText: ''
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(prompt: string, useLastNote: boolean, inputCallback: (data: string) => void, maxLength?: number, initialText?: string, position?: DialogPositionType) {
        this.safeSetState((draft: State) => {
            draft.prompt = prompt === '' ? 'Please enter new note' : prompt;
            draft.useLastNote = useLastNote;
            draft.position = position;
            draft.visible = true;
            draft.onAddNote = inputCallback;
            draft.noteText = initialText ?? '';
            draft.maxLength = maxLength ?? 10000;
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private async ok_Click() {
        await this.state.onAddNote!(this.state.noteText!);
        this.hide();
    }

    private getDialogTemplate(): ReactNode {
        return (
            <div className="formgrid grid">
                <div className="col-12 md:col-12">
                    <p>{this.state.prompt}</p>
                </div>
                <div>
                    <MTextArea id={'noteText'}
                               maxLength={this.state.maxLength}
                               disabled={false}
                               initialValue={this.state.noteText}
                               autoResize={true}
                               cols={80}
                               rows={10}
                               onChange={this.onNoteChange}
                    />
                </div>
            </div>);
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={!this.isUploadAvailable()}
                         onClick={this.ok_Click}/>
                <MButton label={this.state.useLastNote ? 'Use Last Note' : 'Cancel'}
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.hide}/>
            </div>
        );
    }

    private onNoteChange(newValue: MInputValueType) {
        this.safeSetState(
            (draft: State) => draft.noteText = newValue.toString());
    }

    private isUploadAvailable() {
        return this.state.noteText?.length > 0;
    }

    /** */
    public render(): ReactElement {

        return (
            <React.Fragment>
                <Dialog title={'Add a new note'}
                        content={this.getDialogTemplate()}
                        icon={{name: 'pi pi-pencil', color: 'mcolor-info'}}
                        footer={this.getFooterTemplate()}
                        position={this.state.position}
                        canClose={false}
                        closeOnEscape={false}
                        visible={this.state.visible}
                        onHide={this.dialog_onHide}
                />
            </React.Fragment>

        );

    }

}

export default NoteDialog;
